import { useCleanupLocalStorageOnPageLoad } from './useCleanupLocalStorageOnPageLoad'
import { useTrackRouteChange } from './useTrackRouteChange'

//hooks to be called in body of _app
export function useAppHooks(): void {
  useTrackRouteChange()
  useCleanupLocalStorageOnPageLoad()
}
//
